import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import * as styles from './browserCanvas.module.scss';
import template from './BrowserCanvasView.html';
let BrowserCanvasComponent = class BrowserCanvasComponent {
    static $inject = ['BLIP_DOMAIN'];
    constructor(BLIP_DOMAIN) {
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.styles = styles;
    }
};
BrowserCanvasComponent.$inject = ['BLIP_DOMAIN'];
BrowserCanvasComponent = __decorate([
    Component({
        template,
        bindings: {
            subdomain: '@?',
            name: '@?',
        },
    }),
    __metadata("design:paramtypes", [String])
], BrowserCanvasComponent);
export { BrowserCanvasComponent };
